// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2ZIRq","footerLabel":"Footer_footerLabel__3414e"};